import React, { FC } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import QRCode from 'react-qr-code';
import BaseModal from '../BaseModal';
import { Contents, CodeWrapper, DoneButton } from './styled';

interface DownloadAppModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DownloadAppModal: FC<DownloadAppModalProps> = ({ isOpen, onClose }) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      heading="Scan the QR code to download the app"
    >
      <Contents>
        <CodeWrapper>
          <QRCode
            size={256}
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
            value={`${process.env.REACT_APP_URL}/download-app`}
            viewBox="0 0 256 256"
          />
        </CodeWrapper>
        Available on iOS and Android
        <DoneButton color="pickledBluewood" onClick={onClose}>
          Done
        </DoneButton>
      </Contents>
    </BaseModal>
  );
};

export default DownloadAppModal;
